/**
 * Cliente API de Ley 21.719 (Sprint 18 P10 + P25).
 *
 * Portabilidad (descargar datos) + cancelación (solicitar eliminación de
 * cuenta) para el vecino, y cola de la Comisión para resolver.
 */
import { apiFetch } from './client';

export interface SolicitudEliminacionRead {
  id: string;
  persona_id: string;
  usuario_id: string;
  estado: 'pendiente' | 'ejecutada' | 'rechazada';
  motivo: string | null;
  resuelta_at: string | null;
  resuelta_por_usuario_id: string | null;
  motivo_resolucion: string | null;
  creado_at: string;
  actualizado_at: string;
}

export interface SolicitudEliminacionConPersonaRead
  extends SolicitudEliminacionRead {
  persona_nombre: string;
}

/** Descarga el JSON con los datos personales del vecino (portabilidad).
 * Hace el fetch y dispara la descarga del archivo en el navegador. */
export async function descargarMisDatos(): Promise<void> {
  const datos = await apiFetch<unknown>('/me/datos-personales/export');
  const blob = new Blob([JSON.stringify(datos, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'mis-datos-calbucura.json';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function solicitarEliminacion(
  motivo: string | null,
): Promise<SolicitudEliminacionRead> {
  return apiFetch<SolicitudEliminacionRead>('/me/solicitar-eliminacion', {
    method: 'POST',
    body: JSON.stringify({ motivo }),
  });
}

// === Comisión ===

export function listarEliminaciones(
  estado?: string,
): Promise<SolicitudEliminacionConPersonaRead[]> {
  const qs = estado ? `?estado=${encodeURIComponent(estado)}` : '';
  return apiFetch<SolicitudEliminacionConPersonaRead[]>(
    `/admin/eliminaciones${qs}`,
  );
}

export function ejecutarEliminacion(
  id: string,
): Promise<SolicitudEliminacionRead> {
  return apiFetch<SolicitudEliminacionRead>(
    `/admin/eliminaciones/${id}/ejecutar`,
    { method: 'POST' },
  );
}

export function rechazarEliminacion(
  id: string,
  motivoResolucion: string,
): Promise<SolicitudEliminacionRead> {
  return apiFetch<SolicitudEliminacionRead>(
    `/admin/eliminaciones/${id}/rechazar`,
    {
      method: 'POST',
      body: JSON.stringify({ motivo_resolucion: motivoResolucion }),
    },
  );
}
